import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { authenticationAccount } from '@biz-action/user-actions/account-actions';
import { TenantAccount } from '@biz-models/shared/current-user.model';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { base_url, consolidateURL, environment, redirect_url } from 'src/environments/environment';
import { LoginService } from '../services/login.service';
import { SubdomainList } from './selectors';

@Component({
	selector: 'app-select-subdomain',
	templateUrl: './select-subdomain.component.html',
	styleUrls: ['./select-subdomain.component.scss'],
})
export class SelectSubdomainComponent implements OnInit {
	subdomainForm: UntypedFormGroup;
	subdomain = environment.subdomain;
	public consolidateURL = consolidateURL;
	loading = false;
	subdomains$: Observable<TenantAccount[]>;
	selectedIndex: number;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private formBuilder: UntypedFormBuilder,
		private loginService: LoginService,
		private store: Store,
	) {}

	ngOnInit(): void {
		this.subdomainForm = this.formBuilder.group({
			subdomain: ['', Validators.required],
			subdomain_type: [''],
			redirect: [''],
			token: [''],
			signature: [''],
			// password: ['', Validators.required],
			// username: ['', Validators.required]
		});
		// show subdomains selector
		this.store.dispatch(authenticationAccount.loadsubdomainlist());
		this.subdomains$ = this.store.select(SubdomainList).pipe(
			// auto select if has query param
			tap((r) => {
				const index = r.findIndex((i) => i.subdomain === this.route.snapshot.queryParamMap.get('_subdomain'));
				if (index >= 0) {
					this.chooseSubdomain(r[index], index);
					this.submit();
				}
			}),
		);
	}

	submit() {
		if (this.subdomainForm.invalid) {
			this.subdomainForm.markAllAsTouched();
			return;
		}

		this.store.dispatch(authenticationAccount.loginsubdomain(this.subdomainForm.value));
	}

	chooseSubdomain(data: TenantAccount, index: number) {
		this.subdomainForm.controls['subdomain'].setValue(data.subdomain);
		this.subdomainForm.controls['token'].setValue(data.token);
		this.subdomainForm.controls['signature'].setValue(data.signature);
		this.subdomainForm.controls['subdomain_type'].setValue(data.subdomain_type);
		this.subdomainForm.controls['redirect'].setValue(data.redirect);
		// clear other selected
		// this.array.forEach((data) => {
		// 	data.selected = false;
		// });
		// data.selected = true;
		this.selectedIndex = index;
	}
}
